//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {mapState} from "vuex";

export default {
  name: "InfoPanel",

  computed: {
    imgSrc () {
      const img = this.currentItem && this.currentItem.images && this.currentItem.images[0];
      if (!img) return require('../assets/no-image.png');

      // only replace the last ".jpg" if present; otherwise keep original
      return img.endsWith('.jpg') ? img.replace(/\.jpg$/i, '_thumb.jpg') : img;
    },
    ...mapState({
      currentItem: state => {
        return state.monuments.selectedItem;
      }
    })
  },

  methods: {
    onImgError (evt) {
      const fallback = require('../assets/no-image.png');
      const original = this.currentItem?.images?.[0];

      if (!evt || !evt.target) return;

      // if thumb failed, try original once
      if (original && evt.target.src.includes('_thumb')) {
        evt.target.src = original;
        return;
      }

      // otherwise show fallback
      if (!evt.target.src.includes('no-image.png')) {
        evt.target.src = fallback;
      }
    },
    formatGPSCoord(number) {
      return parseFloat(number).toFixed(6);
    },
    openPhotoDatesDialog() {
      if (this.currentItem && this.currentItem.images.length > 0) this.$store.dispatch("monuments/toggleAlbumDatesDialog");
    },
  },

  components: {}
};
